// extracted by mini-css-extract-plugin
export default {"tooltiptrigger":"Tooltip_tooltiptrigger__REoq0","tooltiptext":"Tooltip_tooltiptext__TVW89","tooltiptext-right":"Tooltip_tooltiptext-right__mMLFZ"};